<template>
  <span class="inline-block" :class="`text-${color} ${rotate}`">
    <component :is="icon" :width="size" :height="size" :color="color" />
  </span>
</template>

<script>
import PauseIcon from '@/components/icons/IconPause.vue'
import PlayIcon from '@/components/icons/IconPlay.vue'
import CloseIcon from '@/components/icons/IconClose.vue'
import BurgerIcon from '@/components/icons/IconBurger.vue'
import ArrowIcon from '@/components/icons/IconArrow.vue'
import ChevronIcon from '@/components/icons/IconChevron.vue'
import galleryicon from '@/components/icons/IconGallery.vue'
import videoicon from '@/components/icons/IconVideo.vue'
import articleicon from '@/components/icons/IconArticle.vue'
import panoramaicon from '@/components/icons/IconPanorama.vue'
import LocationIcon from '@/components/icons/IconLocation.vue'
import facebookicon from '@/components/icons/IconFacebook.vue'
import instagramicon from '@/components/icons/IconInstagram.vue'
import youtubeicon from '@/components/icons/IconYoutube.vue'
import linkedinicon from '@/components/icons/IconLinkedin.vue'
import twittericon from '@/components/icons/IconTwitter.vue'
import LinkIcon from '@/components/icons/IconLink.vue'
import CenterIcon from '@/components/icons/IconCenter.vue'
import PlusIcon from '@/components/icons/IconPlus.vue'
import MinusIcon from '@/components/icons/IconMinus.vue'
import ChatIcon from '@/components/icons/IconChat.vue'

export default {
  name: 'IconBase',
  components: {
    PauseIcon,
    PlayIcon,
    CloseIcon,
    BurgerIcon,
    ArrowIcon,
    ChevronIcon,
    galleryicon,
    videoicon,
    articleicon,
    panoramaicon,
    LocationIcon,
    facebookicon,
    instagramicon,
    youtubeicon,
    linkedinicon,
    twittericon,
    LinkIcon,
    CenterIcon,
    PlusIcon,
    MinusIcon,
    ChatIcon
  },

  props: {
    icon: {
      type: String,
      default: 'arrow'
    },
    size: {
      type: String,
      default: '1.5rem'
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    rotate: {
      type: String,
      default: ''
    }
  }
}
</script>
